/**
 * Created by dreamc_t on 2017/3/29.
 */

var Events = require('f.core.event');

var currentStatus = {
    headPageNo: -1, //最前接收的最后的页号
    headPageReceiveLength: 0, //最前接收页号接收的最后一条数据mid
    tailPageNo: 10000000, //数据尾接收的页号
    tailPageReceiveLength: 0, //数据尾接收的最后一条数据的mid
    topMid: -1, //最后一次接收的置顶消息
    update: 0, //最后一次接收新数据的更新时间
};

var hasUpdate = false; //是否有新数据
var receivingDatas = {}; //接收中的数据
var reveiveParam = null; //接收到的元数据对象
//默认是5秒轮询param一次，该数据会根据查询的接口进行变化,f4与cdn的接口轮询周期不一样
var interval = -1;
var itemCache = {}; //item id的缓存列表

var lastUpdateTime = null; //最后一次更新时间
var receiveLengthReset = false; //是否需要重置，这是为currentStatus.tailPageReceiveLength特殊处理
var total = 0; //图文直播的总页数

var live_content = {
    //获取索引文件成功，服务器端回调函数(data:索引文件数据对象)
    success: function(data) {
        reveiveParam = data;
    },
    //获取单页数据成功，服务器端回调函数(dataList:单页数据列表 ， pageIndex：文件索引号)
    singleSuccess: function(dataList, pageIndex) {
        receivingDatas[pageIndex] = dataList;
    },
};

window.live_content = live_content;

var DataCenter = function(options) {
    this.options = options;
    this.init(options);
};

DataCenter.prototype.init = function(options) {
    this.runStatus = 'running'; //运行状态， stop | running
    this.options = options;
    this.sortType = 'desc';
    this.paramError = false; //数据请求异常
    this.requestParam();
};

DataCenter.prototype.requestParam = function() {
    /**
     *  定时请求param数据，请求最新的索引文件
     */
    var _self = this;

    if (!this.paramError) {
        //如果有异常则调用cdn
        interval = interval == -1 ? this.options.f4Interval : interval;

        this.request(
            this.options.f4Addr + this.getParamUrl(),
            function() {
                interval = this.options.cdnInterval;
                this.options.livestatus = 0; //设置为关闭状态
                this.paramError = true;
                _self.request(
                    this.options.cdnAddr + this.getParamUrl(),
                    function() {
                        setTimeout(function() {
                            _self.requestParam(_self.options);
                        }, interval); //TODO 失败后继续查询，失败多次后需要有策略减少y0服务器的请求
                    },
                    _self.processParamData,
                );
            },
            _self.processParamData,
        );
    } else {
        //如果是关闭则直接调用cdn地址
        interval = interval == -1 ? this.options.cdnInterval : interval;
        this.request(
            this.options.cdnAddr + this.getParamUrl(),
            function() {
                setTimeout(function() {
                    _self.requestParam(_self.options);
                }, interval); //TODO 失败后继续查询
            },
            _self.processParamData,
        );
    }
};

DataCenter.prototype.request = function(requestUrl, errorFn, sucessFn) {
    var _self = this;
    $.getScript(requestUrl)
        .done(function(script, textStatus) {
            sucessFn.apply(_self);
        })
        .fail(function(jqxhr, settings, exception) {
            errorFn.apply(_self);
        });
};

/**
 * 得到请求的地址
 */
DataCenter.prototype.getRequestHostAddr = function() {
    var host = '';

    host = this.options.livestatus == 1 ? this.options.f4Addr : this.options.cdnAddr;

    return host;
};
/*获取最终请求时间间隔*/

DataCenter.prototype.getOrgiInterval = function() {
    var interval = this.options.livestatus == 1 ? this.options.f4Interval : this.options.cdnInterval;
    return interval;
};

/**
 * 处理请求下来的param数据
 * @param paramData
 *        total    有多少个数据文件(多少页)
 *        status   直播间开启关闭状态，1为开启状态，0为关闭状态
 *        update   数据更新时间，时间戳。（只在创建消息时修改）
 *        topMid   置顶消息ID
 *        topPage  置顶消息所在数据文件页数
 */
DataCenter.prototype.processParamData = function() {
    var _self = this;

    var paramData = reveiveParam;
    reveiveParam = {};
    if (paramData.status) {
        //如果当前是正常状态则重置params的请求路径
        this.paramError = false;
    }
    total = paramData.total; //当前总数页
    if (currentStatus.update == 0) {
        //系统初始状态
        currentStatus.update = paramData.update;
        var reqPageIndex = []; //请求的数据页面
        var reqCount = 0;

        /**
         * 数据请求
         * @param pageIndex 请求页
         * @param nextPageFn 当数据不够时下一页的方法
         * @param pageIndexConditionFn  判断请求页是否超过最大或最小
         */
        var req = function(pageIndex, nextPageFn, pageIndexConditionFn) {
            _self.requestData(pageIndex, function(pageIndex, dataList) {
                reqPageIndex.push(pageIndex);
                reqCount += dataList.length;
                if (reqCount >= _self.options.reqPageSize || pageIndexConditionFn(pageIndex)) {
                    //TODO 当升序时不需要
                    //数据已经获取完毕，记录当前请求状态调用显示
                    // console.log('currentStatus.tailPageNo : '+ currentStatus.tailPageNo);
                    _self.tailData(reqPageIndex, _self.options.reqPageSize);
                    _self.setTimeoutParam();
                } else {
                    req(nextPageFn(pageIndex), nextPageFn, pageIndexConditionFn);
                }
            });
        };
        if (this.sortType == 'asc') {
            //升序查询
            req(
                1,
                function(pageIndex) {
                    return pageIndex + 1;
                },
                function(pageIndex) {
                    return pageIndex + 1 > total;
                },
            );
        } else {
            //降序查询
            req(
                total,
                function(pageIndex) {
                    return pageIndex - 1;
                },
                function(pageIndex) {
                    return pageIndex - 1 < 1;
                },
            );
        }
        _self.processTop(paramData);
    } else if (paramData.update > currentStatus.update && this.sortType == 'desc') {
        //检测到有数据更新，只有时间大于时上次请求才会更新,当升序时不在请求数据

        //console.log('有更新！~');
        currentStatus.update = paramData.update;
        var reqPageIndex = []; //请求的数据页面
        interval = _self.getOrgiInterval();
        //lostTime = 0;
        var req = function(pageIndex, maxTotal) {
            _self.requestData(pageIndex, function(pageIndex, dataList) {
                reqPageIndex.push(pageIndex);
                if (pageIndex + 1 <= maxTotal) {
                    //继续请求页面
                    req(pageIndex + 1, maxTotal);
                } else {
                    //没有数据需要获取
                    _self.headData(reqPageIndex, true);
                    // hasUpdate = false; //数据添加到页面后设置为无数据更新
                    _self.setTimeoutParam();
                }
            });
        };
        req(currentStatus.headPageNo, total); //请求数据,从最低开始请求
        _self.processTop(paramData);
    } else {
        //没有数据更新，检查没有更新的时间总量 lostTime > 10 * 60 * 1000 ,
        var curDate = new Date();
        if (lastUpdateTime == null) {
            lastUpdateTime = curDate;
            // console.log('lastUpdateTime === paramData.update:' + lastUpdateTime === paramData.update);
        } else {
            if (
                curDate.getTime() - lastUpdateTime.getTime() >= _self.options.increaseabelRange &&
                interval < _self.options.updateMaxTime
            ) {
                interval += _self.options.timeIncrease;
                lastUpdateTime = curDate;
            }
        }
        this.setTimeoutParam();
        return;
    }
};

DataCenter.prototype.requestMore = function(completeFn) {
    if (currentStatus.tailPageNo === 0) {
        return;
    }
    var _self = this;
    var reqPageIndex = []; //请求的数据页面
    var reqCount = 0;

    var req = function(pageIndex, nextPageFn, pageIndexConditionFn) {
        _self.requestData(pageIndex, function(pageIndex, dataList) {
            reqPageIndex.push(pageIndex);
            if (currentStatus.tailPageReceiveLength == 0) {
                currentStatus.tailPageReceiveLength = dataList.length;
                currentStatus.tailPageNo += 1;
            }
            reqCount +=
                currentStatus.tailPageNo == pageIndex
                    ? dataList.length - currentStatus.tailPageReceiveLength
                    : dataList.length;
            if (reqCount > _self.options.reqPageSize || pageIndexConditionFn(pageIndex)) {
                // currentStatus.tailPageNo = pageIndex - 1;
                //数据已经获取完毕，记录当前请求状态调用显示

                _self.tailData(reqPageIndex, _self.options.reqPageSize);
                if (completeFn) {
                    completeFn();
                }
            } else {
                req(nextPageFn(pageIndex), nextPageFn, pageIndexConditionFn);
            }
        });
    };
    if (this.sortType == 'asc') {
        //升序
        req(
            currentStatus.tailPageNo,
            function(pageIndex) {
                return pageIndex + 1;
            },
            function(pageIndex) {
                return pageIndex + 1 > total;
            },
        );
    } else {
        //降序
        //console.log('currentStatus.tailPageNo : '+ currentStatus.tailPageNo);
        req(
            currentStatus.tailPageNo,
            function(pageIndex) {
                return pageIndex - 1;
            },
            function(pageIndex) {
                return pageIndex - 1 < 1;
            },
        );
    }
};

DataCenter.prototype.setTimeoutParam = function() {
    var _self = this;
    if (this.runStatus != 'stop') {
        setTimeout(function() {
            _self.requestParam();
        }, interval);
    }
};

/*停止请求*/

DataCenter.prototype.stop = function() {
    this.runStatus = 'stop';
    // console.log(this.runStatus);
};

DataCenter.prototype.start = function() {
    if (this.runStatus == 'stop') {
        this.runStatus = 'running';
        this.requestParam();
    }
};

DataCenter.prototype.restart = function(sortType) {
    //清除数据
    this.sortType = sortType;
    this.trigger('clear', this.options.itemList);
    this.stop(); //停止请求数据
    //重置初始参数
    //当前数据状态
    currentStatus = {
        headPageNo: -1, //最前接收的最后的页号
        headPageReceiveLength: 0, //最前接收页号接收的最后一条数据mid
        tailPageNo: 10000000, //数据尾接收的页号
        tailPageReceiveLength: 0, //数据尾接收的最后一条数据的mid
        topMid: -1, //最后一次接收的置顶消息
        update: 0, //最后一次接收新数据的更新时间
    };
    hasUpdate = false;
    receivingDatas = {}; //接收中的数据
    reveiveParam = null; //接收到的元数据对象
    //默认是5秒轮询param一次，该数据会根据查询的接口进行变化,f4与cdn的接口轮询周期不一样
    interval = -1;
    itemCache = {}; //item id的缓存列表
    lastUpdateTime = null; //最后一次更新时间
    receiveLengthReset = false;
    this.start();
};

/**
 * 处理置顶信息，使用jquery getScript方式，得到的数据是reveiveParam
 * @param paramData 请求数据的元数据
 */
DataCenter.prototype.processTop = function(paramData) {
    //装载指定消息
    var _self = this;
    var hostAdd = this.getRequestHostAddr();
    if (paramData.topMid && paramData.topMid != currentStatus.topMid) {
        //处理置顶消息
        $.getScript(hostAdd + _self.getDataUrl(paramData.topPage)).done(function() {
            var items = receivingDatas[paramData.topPage];
            if (currentStatus.topMid != '-1') {
                //非初始化状态
                var hasUpdateTop = true;
            } else {
                var hasUpdateTop = false;
            }

            for (var i = 0; i < items.length; i++) {
                if (paramData.topMid == items[i].mid) {
                    currentStatus.topMid = items[i].mid;
                    _self.topItem = items[i];
                    _self.trigger('top', items[i], hasUpdateTop);
                    break;
                }
            }
        });
    }
};

/**
 * 得到数据
 * @param pageIndex 数据页号
 * @param fn  数据返回后的回调函数
 */
DataCenter.prototype.requestData = function(pageIndex, fn) {
    var _self = this;
    var hostAdd = this.getRequestHostAddr();
    $.getScript(hostAdd + _self.getDataUrl(pageIndex)).done(function() {
        fn(pageIndex, receivingDatas[pageIndex]);
    });
};

/**
 * 添加数据到头
 * @param pageIndexs 添加数据的索引页位置列表
 */
DataCenter.prototype.headData = function(pageIndexs, hasUpdate) {
    var temp = [];
    for (var i = 0; i < pageIndexs.length; i++) {
        if (currentStatus.tailPageNo == -1) {
            currentStatus.tailPageNo = pageIndexs[i]; //如果没有设置tailPageNo则初始化
        }
        var items = receivingDatas[pageIndexs[i]];
        items.sort(function(a, b) {
            //需要升序
            return a.mid - b.mid;
        });
        for (var j = 0; j < items.length; j++) {
            var item = items[j];
            if (!itemCache[item.mid]) {
                itemCache[item.mid] = true;
                temp.push(item);
            }
        }
    }
    if (temp.length > 0) {
        this.options.itemList.unshift.apply(this.options.itemList, temp);
        // console.log('hasUpdate:'+hasUpdate);
        this.trigger('head', temp, hasUpdate);
    }
};

/**
 * 添加数据到尾
 * @param pageIndexs 添加数据的索引页位置列表
 * @param showCount  需要显示的数量
 */
DataCenter.prototype.tailData = function(pageIndexs, showCount, hasUpdate) {
    var count = 0;
    var temp = [];
    for (var i = 0; i < pageIndexs.length; i++) {
        var items = receivingDatas[pageIndexs[i]];

        if (currentStatus.headPageNo == -1) {
            currentStatus.headPageNo = pageIndexs[i]; //如果没有设置headPageNo则初始化
        }

        if (this.sortType == 'desc') {
            // console.log('currentStatus.tailPageNo :' + currentStatus.tailPageNo);
            for (var j = 0; j < items.length; j++) {
                var item = items[j];
                // console.log(itemCache);
                if (
                    count < showCount && //总数控制
                    (currentStatus.tailPageNo > pageIndexs[i] ||
                        (pageIndexs[i] == currentStatus.tailPageNo && currentStatus.tailPageReceiveLength < j)) &&
                    !itemCache[item.mid]
                ) {
                    currentStatus.tailPageReceiveLength = j;
                    currentStatus.tailPageNo = pageIndexs[i];
                    itemCache[item.mid] = true;
                    temp.push(item);
                    count++;
                }
            }
            //console.log('currentStatus.tailPageNo :' + currentStatus.tailPageNo);
            if (currentStatus.tailPageNo == 1 && currentStatus.tailPageReceiveLength + 1 == receivingDatas[1].length) {
                $('.mod-showMoreBtn').hide();
            }
        } else {
            //升序需要对数据排序
            if (currentStatus.tailPageNo == 10000000) {
                currentStatus.tailPageNo = 1;
            }
            if (currentStatus.tailPageReceiveLength == 0 && receiveLengthReset == false) {
                currentStatus.tailPageReceiveLength = items.length;
                receiveLengthReset = true;
            }
            for (var j = items.length - 1; j >= 0; j--) {
                if (
                    count < showCount && //总数控制
                    (currentStatus.tailPageNo < pageIndexs[i] ||
                        (pageIndexs[i] == currentStatus.tailPageNo && currentStatus.tailPageReceiveLength > j))
                ) {
                    currentStatus.tailPageReceiveLength = j; //当前文件读的位置
                    currentStatus.tailPageNo = pageIndexs[i];
                    var item = items[j];
                    itemCache[item.mid] = true;
                    temp.push(item);
                    count++;
                }
            }
        }
    }

    if (temp.length > 0) {
        this.options.itemList.push.apply(this.options.itemList, temp);

        this.trigger('tail', temp);
    }
};

DataCenter.prototype.replaceImgServer = function(imageAddr) {
    if (imageAddr == '') return '';
    return this.options.imageServer + '/' + this.options.imageRatio + '/' + imageAddr.replace(/http[s]?:\/\//, '');
};

DataCenter.prototype.getParamUrl = function() {
    return this.options.liveid + '/param.json';
};

DataCenter.prototype.getDataUrl = function(pageIndex) {
    return this.options.liveid + '/' + pageIndex + '.json';
};

Events.mixTo(DataCenter);

module.exports = DataCenter;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.datacenter.mobile/index.js